<template>
  <div class="hold">
    <div class="sidebar elevated" :class="{active: sidebarActive }">
      <sidebar></sidebar>
    </div>
    <div class="content" :class="{sidebarActive}">
      <div class="scoped-overlay" :class="{sidebarActive}" @click.prevent="$store.commit('TOGGLE_VISIBILITY')"></div>
      <div class="nav-coner" :class="{sidebarActive}">
        <navbar></navbar>
      </div>
      <div class="sub-content">
<!--        <div style="background-color:grey;color:white;">-->
<!--          <em>-->
<!--            Dear Tutor, kindly note that Prepclass is only hiring Full-Time Teachers, interested in working full-time with prepclass, please register your details here <a href="http://bit.ly/tutorapplication3">http://bit.ly/tutorapplication3</a>-->
<!--            </em>-->
<!--          </div>-->
        <router-view></router-view>
        <div class="footer">
          <span>Are you experiencing any issues? &nbsp;<a href="https://docs.google.com/forms/d/e/1FAIpQLScWBN0KREUpTmh3zePNM9XHVwYCSNbEmgaYpTww7autVig4NQ/viewform" target="_blank">Click here</a></span>
          <span class="hide-on-small-only">&nbsp; to fill &nbsp;<a href="https://docs.google.com/forms/d/e/1FAIpQLScWBN0KREUpTmh3zePNM9XHVwYCSNbEmgaYpTww7autVig4NQ/viewform" target="_blank"> our complaint form</a>.</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Sidebar from './Sidebar';
import Navbar from './Navbar';

export default {
  name: 'dashboard-index',
  components: { Sidebar, Navbar },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (vm.$auth.user().has_active_classes) {
        return true;
      }
      axios.get(`${BASE_API}/v1/tutor/${vm.$auth.user().id}/passed-test`)
        .then(({ data: { status } }) => {
          console.log(status);
          if (!status) {
            return vm.$router.push({ name: 'test-status' });
          }
          return true;
        })
        .catch(error => console.error(error));
      return true;
    });
  },
  computed: {
    sidebarActive() {
      return this.$store.getters.sidebar_visible;
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.sidebar {
  width: 215px;
  height: 100vh;
  overflow: hidden;
  overflow-y: auto;
  background-color: #202030;
  border-radius: 0;
  z-index: 10;
}

.content {
  height: 100vh;
  width: calc(100vw - 215px);
  overflow: auto;
  position: relative;
}
.nav-coner {
  width: calc(100vw - 215px);
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9;
}
.sub-content {
  margin-top: 70px;
}
.hold {
  display: flex;
  flex-direction: row;
  overflow: hidden;
  overflow-y: auto;
}
@media only screen and (max-width: 600px) {
  .hold {
    width: 100vw;
    height: 100vh;
    position: relative;
    overflow: hidden;
    margin-top: 0 !important;
  }
  .sidebar {
    left: -100%;
    position: absolute;
    background-color: #202030;
    transition: all .3s ease;
    &.active {left: 0;}
  }
  .nav-coner {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9;
    transition: all .3s ease;
    &.sidebarActive {left: 215px;}
  }
  .scoped-overlay {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    margin: 0;
    z-index: 99999999999;
    background-color: rgba(255, 255, 255, 0.28);
    &.sidebarActive {left: 215px; display: block;}
  }
  .content {
    left: 0;
    position: absolute;
    width: 100vw;
    transition: all .3s ease;

    overflow-y: scroll; /* has to be scroll, not auto */
    -webkit-overflow-scrolling: touch;
    &.sidebarActive {
      position: absolute;
      left: 215px;
    }
  }
}
.footer {
    // display: none;
    flex-direction: column;
    margin-top: 0px;
    margin-bottom: 10px;
    margin-right: auto;
    margin-left: auto;
    padding: 8px 15px;
    width: fit-content;
    font-size: 12px;
    font-weight: 400;
    border-radius: 25px;
    background: white;
    color: #576271;
    // float: right;
    box-shadow: 0 8px 17px 2px rgba(200, 200, 200, 0.14), 0 3px 14px 2px rgba(200, 200, 200, 0.12), 0 5px 5px -3px rgba(200, 200, 200, 0.2);
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/Dashboard/Index.vue